<div class="card skeleton-card" [ngStyle]="{ 'min-height.px': minHeight }">
    <div class="card-body">
        <!-- Başlık alanı -->
        <div *ngIf="showTitle" class="skeleton-line skeleton-title mb-3"></div>

        <!-- Satır satır info -->
        <div *ngFor="let _ of linesArray; let i = index" class="skeleton-line mb-2" [ngClass]="{
           'w-75': i === 0,
           'w-50': i === 1,
           'w-100': i > 1
         }">
        </div>

        <!-- Badge alanları -->
        <ng-container *ngIf="showBadges">
            <hr>
            <div *ngFor="let _ of badgesArray" class="skeleton-badge mb-2"></div>
        </ng-container>
    </div>
</div>